import { secondAxios } from "../../../../api/axios";

export const getCompanyVendors = async () => {
  const getCompanyVendorsApi = "/vendor";
  const { data } = await secondAxios.get(getCompanyVendorsApi);
  return data;
};

export const addNewVendor = async (companyId, vendor) => {
  const addVendorsApi = `/vendor/add-vendors`;
  const { data } = await secondAxios.post(addVendorsApi, [vendor]);
  return data;
};

export const editVendor = async (id, vendorData) => {
  const editVendorApi = `/vendor/` + id;
  const { data } = await secondAxios.post(editVendorApi, vendorData);

  console.log({ data });
  return data;
};

export const deleteVendor = async (vendorId) => {
  const deleteVendorApi = `/vendor/` + vendorId;

  const { data } = await secondAxios.delete(deleteVendorApi);
  return data;
};
